module.exports = __webpack_public_path__ + "img/34.5a0c2639.png";